import { render } from "./orderWelcomeCard.vue?vue&type=template&id=e22a1d96&scoped=true"
import script from "./orderWelcomeCard.vue?vue&type=script&lang=js"
export * from "./orderWelcomeCard.vue?vue&type=script&lang=js"

import "./orderWelcomeCard.vue?vue&type=style&index=0&id=e22a1d96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e22a1d96"]])

export default __exports__